import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getETLProcessList(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/admin/processes/`, oauthTokenHeader);
}

function getProcessList(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/filters/?filters=etl_process_name`, oauthTokenHeader);
}

function createETLProcess(data: any, oauthTokenHeader: string) {
  return fetchWrapper.post(
    `${apiUrl}/admin/processes/`,
    data,
    oauthTokenHeader
  );
}

function editETLProcess(data: any, oauthTokenHeader: string) {
  return fetchWrapper.put(`${apiUrl}/admin/processes/`, data, oauthTokenHeader);
}

function toggleETLProcess(
  process_id: number,
  data: any,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/admin/processes/toggle/${process_id}/`,
    data,
    oauthTokenHeader
  );
}

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader
  );
}

export const etlProcessListService = {
  getETLProcessList,
  getProcessList,
  createETLProcess,
  editETLProcess,
  toggleETLProcess,
  getAllUsers,
};
